import { getDefaultDeliveriesAndCollectionForProduct } from './defaultChannelsAvailabilitiesConverter';

export function convertProductsData(productsListFromRedux, ucmsHierarchy) {

  return productsListFromRedux.map(
    (product) => ({
      addedValueMessages: product.promoMessages.dealsAvailable
        ? product.promoMessages.dealsAvailable.map(
          (deal) => ({
            show: deal.show,
            title: deal.title // TODO: add from, to attributes here
          })
        )
        : [],
      availabilityMessage: null, // TODO check data which should be here
      category: {
        universeId: product.productCategorisation.universeId,
        categoryId: product.productCategorisation.categoryId,
        marketId: product.productCategorisation.marketId,
        segmentId: product.productCategorisation.segmentId,
        universe: product.productCategorisation.universeName,
        primaryCategory: product.productCategorisation.categoryName,
        market: product.productCategorisation.marketName,
        segment: product.productCategorisation.segmentName
      },
      cisEligible: product.delivery.isReserveAndCollect,
      collectionType: product.boxType === 'outfit' ? 'Outfit' : null,
      currentPrice: Number(product.price.currentPrice.substr(1)),
      displayCompare: product.displayCompare,
      downloadEligible: product.boxType === 'download',
      emailMeBack: !!getDefaultDeliveriesAndCollectionForProduct(product).showEmailMeBack,
      financingAvailable: !!product.isOnlineCreditAvailable,
      hdEligible: product.delivery.isHomeDelivery,
      inStock: (typeof getDefaultDeliveriesAndCollectionForProduct(product).delivery === 'object' &&
        getDefaultDeliveriesAndCollectionForProduct(product).delivery.type === 'homeDeliveryAvailable') ||
        (typeof getDefaultDeliveriesAndCollectionForProduct(product).inStore === 'object' &&
          getDefaultDeliveriesAndCollectionForProduct(product).inStore.type === 'collectInStoreAvailable'),
      isBundle: product.boxType === 'outfit',
      isForwardOrder: product.forwardOrder && product.forwardOrder.available,
      isPreOrder: product.preOrder && product.preOrder.available,
      manufacturer: product.brand.title,
      numberOfReviews: product.review ? product.review.reviewCount : null,
      pacEligible: product.delivery.isPayAndCollect,
      perMonthPrice: null, // TODO: implement this if tariff product will be supported in future
      productID: product.id,
      productName: product.title,
      productSKU: product.sku,
      reviewRating: product.review ? product.review.score : null,
      savingsPrice: product.price.savingsPrice ? Number(product.price.savingsPrice.substr(1)) : 0,
      separateSellingPrice: null, // TODO: check where to gather analytics
      wasPrice: product.price.wasPrice ? Number(product.price.wasPrice.substr(1)) : 0,
      wasPriceFrom: product.price.wasPriceFrom ? product.price.wasPriceFrom : null,
      wasPriceTo: product.price.wasPriceTo ? product.price.wasPriceTo : null
    })
  );
}
